import React, { useMemo } from 'react';
import { type I18nLocale } from '@ardoq/i18n';
import { Locale } from '@ardoq/locale';
import { Navigator } from '../components/Navigator';
import { LoadDataError } from '../components/LoadDataError';
import { LoadDataNotification } from '../components/LoadDataNotification';
import { EmptyFilterResult } from '../components/EmptyFilterResult';
import { getSelectParentConfiguration } from './selectParentConfiguration';

type SelectParentRootProps = {
  i18nLocale: I18nLocale;
  locale: Locale;
};

const SelectParentRoot = React.memo(
  ({ i18nLocale, locale }: SelectParentRootProps) => {
    const navigatorConfiguration = useMemo(
      () => ({
        ...getSelectParentConfiguration(locale),
        i18nLocale,
        locale,
      }),
      [i18nLocale, locale]
    );
    return (
      <Navigator
        navigatorConfiguration={navigatorConfiguration}
        LoadDataError={LoadDataError}
        LoadDataNotification={LoadDataNotification}
        EmptyFilterResult={EmptyFilterResult}
      />
    );
  }
);

export { SelectParentRoot };
